import { RecalProcessAndGenConstant } from "presentation/constant/Recalculation/RecalProcessAndGenConstant";
import { useRecalProcessAndGenVM } from "presentation/hook/Recalculation/useRecalProcessAndGenVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useMemo, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RecalProcessAndGenEditPanel = () => {
    const SCREEN_CONSTANT = RecalProcessAndGenConstant;
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const recalProcessAndGenVM = useRecalProcessAndGenVM();
    const { selectRows, isAssignSeq, oneOffRate, seqNo, searchCriteria } = recalProcessAndGenState;
    const [isLoading, setIsLoading] = useState(false);
    const messageBarVM = useMessageBarVM();

    const handleSave = useCallback(async () => {
        setIsLoading(true);
        await recalProcessAndGenVM.onSaveClick(isAssignSeq, seqNo, oneOffRate, selectRows).then(async () => {
            await recalProcessAndGenVM.onSearch(searchCriteria).then(data => {
                setIsLoading(false);
                messageBarVM.showSuccess("Save Successfully.");
            })
        });
    }, [isAssignSeq, messageBarVM, oneOffRate, recalProcessAndGenVM, searchCriteria, selectRows, seqNo]);

    const handClose = useCallback(() => {
        recalProcessAndGenVM.onCloseEditPanel();
    }, [recalProcessAndGenVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        recalProcessAndGenVM.onBulkEditFieldChange(fieldName, fieldValue);
    }, [recalProcessAndGenVM]);

    const memoNewOneoffRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.ONEOFF_RATE}
                maxLength={13}
                fieldName={"oneOffRate"}
                value={oneOffRate ?? ''}
                errorMessage={''}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.ONEOFF_RATE, onNumberFieldChange, oneOffRate])

    const memoSeqNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.SEQ_NO}
                maxLength={10}
                fieldName={"seqNo"}
                value={seqNo ?? ''}
                errorMessage={''}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.SEQ_NO, seqNo, onNumberFieldChange])


    return (
        <div className='side-form-content-wrapper'>
            {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {!isAssignSeq && "Assign/Resume New One-off Rate"}
                            {isAssignSeq && "Assign Seq. No."}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            <div className={'add-edit-form'} style={{ height: '73vh', maxHeight: '73vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        {isAssignSeq
                            ? <>
                                <CriteriaItemContainer>
                                    {memoSeqNo}
                                </CriteriaItemContainer></>
                            : <>
                                <CriteriaItemContainer>
                                    {memoNewOneoffRate}
                                </CriteriaItemContainer>

                            </>
                        }

                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={handClose} />
                <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={handleSave} />
            </SidebarActionBar>
        </div>
    );
}

export default RecalProcessAndGenEditPanel;
